export const CHANGE_PATH = 'CHANGE PATH'

export function changePath(path) {
  return { type: CHANGE_PATH, path }
}
